import { useSelector } from 'react-redux'
import Button from '../../../UI/Button/Button'
import DragAndDrop from '../../../UI/DragAndDrop/DragAndDrop'
import props from '../../../../redux/props'
import { functional } from '@think-internet/zeus-frontend-package'
import Routes from '../../../../redux/routes'
import { useState } from 'react'
import Progress from '../../../UI/Progress/Progress'
import { triggerClientSideDownload } from '../../../../utility'

type Props = {
  callback: () => void
}

const ContactImport: React.FC<Props> = ({ callback }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const uploadContactList = functional.use(Routes.UPLOAD_NAW_CONTACT_LIST)
  const [progress, setProgress] = useState(0)

  const onFile = async (files: File[]) => {
    const file = files[0]
    if (!!file) {
      const result = await uploadContactList({}, null, null, file, setProgress)
      triggerClientSideDownload(result, file.name)
      callback()
    }
  }

  return (
    <div>
      <DragAndDrop className="!w-fit" onFiles={onFile} allowedMimeTypes={['text/csv']} maxFileSizeInBytes={1000000}>
        <Button className="cursor-none" text={t.naw.survey.list.contactImportCTA} />
        <Progress progress={progress} />
      </DragAndDrop>
    </div>
  )
}

export default ContactImport
